import React, { useState, useEffect } from 'react'
import { Helmet } from 'react-helmet'
import Layout from '../components/blog/Layout'
import Quotes from '../components/blog/Quotes'
import { graphql, Link, withPrefix } from 'gatsby'
import styled from 'styled-components'
import SEO from '../components/seo'
import { Card, CardBody, CardSubtitle, Badge } from 'reactstrap'
import Img from 'gatsby-image'
import { slugify } from '../util/utilityFunctions'
import { defineCustomElements as deckDeckGoHighlightElement } from '@deckdeckgo/highlight-code/dist/loader';
import { Disqus } from 'gatsby-plugin-disqus'

deckDeckGoHighlightElement();

const Overlap = styled.div`

    @media (min-width: 768px) {
        margin-top: ${props => props.imageCaps ? 0 : '-100px'};
    }

    @media (max-width: 576px) {
        margin-top: 0;
    }
`

const InnerContent = styled.div`
    
    & > p:first-child {
        font-size: 2rem;
    }



    & > h3 {
        font-weight: 600;
    }

    & > ul {
        list-style: square inside;
    }

    & > ol {
        font-size: 1.1em;
        list-style-type: decimal;
        list-style-position: inside;
    }

    & > ol li > a {
        margin-left: 5px;
    }

    & > p, & > span {
        font-size: 1.05rem;
        line-height: 1.6;
    }

    & > table thead {
        text-align: center;
    }

    & > table tr td {
        padding: 10px;
    }
`

const SinglePost = ({ data, pageContext }) => {
    const post = data.markdownRemark.frontmatter

    const [key, setKey] = useState(undefined)

    useEffect(() => {
        setKey(localStorage.getItem('theme'))
    }, [])

    return (
        <Layout location={{ pathname: `${pageContext.url}` }}
            slug={pageContext.slug}
            quotes={["You Are CSS To My HTML", "Tanpamu, Hidupku Monoton"]}
        >
            <Helmet>
                <body className={key} />
            </Helmet>

            <SEO title={post.title} />
            <div className="row mt-5">
                <div className={`col-lg-12 d-none ${post.imageCaps ? '' : 'd-sm-block'}`}>
                    <Img classNameName="" fluid={post.image.childImageSharp.fluid} />
                </div>
                <Overlap className="col-lg-10 offset-lg-1 col-md-10 offset-md-1"
                    imageCaps={post.imageCaps}
                >
                    <Card style={{
                        backgroundColor: 'var(--card)',
                        color: 'var(--textTitle)',
                        boxShadow: '0 1rem 3rem var(--cardShadowLg)',
                    }}>
                        <CardBody>
                            <h3 className="card-title">{post.title}</h3>
                            <CardSubtitle className="mb-2">
                                <span>Dibuat pada</span>
                                <span>{' '}</span>
                                <span className="text-info">
                                    {post.date}
                                    <span>{' '}</span>
                                </span>
                            </CardSubtitle>
                            {post.tags.map(tag => (
                                <Link to={withPrefix(`blog/tag/${slugify(tag)}`)} key={tag}>
                                    <Badge color="primary" className="mr-2 mb-3">{tag}</Badge>
                                </Link>
                            ))}
                            {
                                post.imageCaps ?
                                    <Img classNameName="" fluid={post.image.childImageSharp.fluid} /> : ''
                            }
                            <br />
                            <InnerContent
                                dangerouslySetInnerHTML={{ __html: data.markdownRemark.html }} />
                        </CardBody>
                    </Card>
                </Overlap>
            </div>
            {
                post.isQuotes ? <Quotes quotes={[post.quotes, post.authorQuotes]} /> : ''
            }

            <Disqus config={{
                url: `https://aryaaaarmdn.netlify.app/${pageContext.url}`,
                identifier: data.markdownRemark.id,
                title: post.title,
            }} className="mt-5" />

        </Layout>
    )
    // formatString: "dddd, MMMM Do YYYY, h:mm:ss a") # Sunday, August 5th 2018, 10:56:14 am
    // date(formatString: "DD MMM YYYY", locale: "id-ID") 
}

export const postQuery = graphql`
    query blogPostBySlug($slug: String!) {
        markdownRemark(fields: { slug: { eq: $slug } }) {
            id
            html
            frontmatter {
                title
                author
                date(formatString: "dddd, DD MMM YYYY, HH:mm:ss", locale: "id-ID") 
                tags
                image {
                    childImageSharp {
                        fluid(maxWidth: 800) {
                            ...GatsbyImageSharpFluid
                        }
                    }
                }
                imageCaps
                isQuotes
                quotes
                authorQuotes
            }
        }
    }
`

export default SinglePost